export const AdhocAgreementStatuses = {
  SENT_UNSIGNED: "SENT_UNSIGNED",
  EXECUTED_PENDING_PAYMENT: "EXECUTED_PENDING_PAYMENT",
  PAID: "PAID",
  VOID: "VOID",
};
